<div class="row eidos-country-state-county" [ngClass]="rowCols">


    <div *ngIf="boolMarket" class="dx-field mb-0 ms-0" [ngClass]="getColClass('market')">
      <div class="dx-field-label text-uppercase">{{labelMarket }}          
        <span class="mandatory" *ngIf="boolRequired && requiredMarket" title="Required Field"> *</span>
      </div>
      <dx-select-box
        #marketBox
        [(value)]="market"
        [dataSource]="lkDs['Market']"
        valueExpr="marketcc"
        displayExpr="marketcc"
        [disabled]="disabled"
        [searchEnabled]="true"
        [showClearButton]="true"
        (onValueChanged)="marketChangeEvent($event)"
        [inputAttr]="{ 'autocomplete': 'do-not-autofill' }"
      >
        <dx-validator *ngIf="boolRequired && requiredMarket">
          <dxi-validation-rule type="required" message="Market is required"></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>
    </div>
  
    <div *ngIf="boolCountry" class="dx-field mb-0 ms-0" [ngClass]="getColClass('country')">
      <div class="dx-field-label text-uppercase">{{ labelCountry }}        
        <span class="mandatory" *ngIf="boolRequired && requiredCountry" title="Required Field"> *</span>
      </div>
      <dx-select-box
        #countryBox
        [(value)]="country"
        [dataSource]="lkDs['Country']"
        valueExpr="CountryCodISO3"
        displayExpr="Country"
        [disabled]="disabled"
        [searchEnabled]="true"
        [showClearButton]="true"
        [inputAttr]="{ 'autocomplete': 'do-not-autofill' }"
      >
        <dx-validator *ngIf="boolRequired && requiredCountry">
          <dxi-validation-rule type="required" message="Country is required"></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>
    </div>
  
    <div *ngIf="boolAddressSearch" class="dx-field mb-0 ms-0" [ngClass]="getColClass('addressSearch', 'col-2x')">
      <div class="dx-field-label text-uppercase">{{ labelAddress }}</div>
      <eidos-address-autocomplete
        [clearDataOnChange]="false"
        [disabled]="!countryIso2 || countryIso2.length === 0"
        [countryIso3]="countryIso"
        [country]="countryIso2 ?? ''"
        (itemAddress)="changeAddressEvent($event)"
      ></eidos-address-autocomplete>
    </div>
  
    <div *ngIf="boolState" class="dx-field mb-0 ms-0" [ngClass]="getColClass('state')">
      <div class="dx-field-label text-uppercase">{{ labelState }} <span class="mandatory" *ngIf="boolRequired && requiredState" title="Required Field"> *</span></div>
      <dx-select-box
        *ngIf="requiredState"
        [disabled]="!countryIso2 || countryIso2.length === 0"
        [(value)]="state"
        [dataSource]="lkDs['State']"
        valueExpr="StateISOCod"
        displayExpr="State"
        [searchEnabled]="true"
        [showClearButton]="true"
        [inputAttr]="{ 'autocomplete': 'do-not-autofill' }"
      >
        <dx-validator *ngIf="boolRequired && requiredState">
          <dxi-validation-rule type="required" message="State is required"></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>

      <dx-text-box
        *ngIf="!requiredState"
        [(value)]="state"
        [inputAttr]="{ autocomplete: 'do-not-autofill' }"
      >
        <dx-validator *ngIf="boolRequired && requiredState">
          <dxi-validation-rule type="required" message="State is required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
  
    <div *ngIf="boolCounty" class="dx-field mb-0 ms-0" [ngClass]="getColClass('county')">
      <div class="dx-field-label text-uppercase">{{ labelCounty }} <span class="mandatory" *ngIf="boolRequired && requiredCounty" title="Required Field"> *</span></div>
      <dx-text-box [(value)]="county" [inputAttr]="{ 'autocomplete': 'do-not-autofill' }">
        <dx-validator *ngIf="boolRequired && requiredCounty">
          <dxi-validation-rule type="required" message="County is required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

  <div *ngIf="boolAddress" class="dx-field mb-0 ms-0" [ngClass]="getColClass('address', 'col-2x')">
      <div class="dx-field-label text-uppercase">{{ labelAddressInput }} <span *ngIf="boolRequired && requiredAddress" class="mandatory" title="Required Field"> *</span></div>
      <dx-text-box [(value)]="address" [inputAttr]="{ 'autocomplete': 'do-not-autofill' }">
        <dx-validator *ngIf="boolRequired && requiredAddress">
          <dxi-validation-rule type="required" message="Address is required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
  </div>

  <div *ngIf="boolCity" class="dx-field mb-0 ms-0" [ngClass]="getColClass('city')">
      <div class="dx-field-label text-uppercase">{{ labelCity }} <span *ngIf="boolRequired && requiredCity" class="mandatory" title="Required Field"> *</span></div>
      <dx-text-box [(value)]="city" [inputAttr]="{ 'autocomplete': 'do-not-autofill' }">
        <dx-validator *ngIf="boolRequired && requiredCity">
          <dxi-validation-rule type="required" message="City is required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
  </div>
  
  <div *ngIf="boolZip && (countryIso2 !== 'US' || !allowZip4)" class="dx-field mb-0 ms-0" [ngClass]="getColClass('zip')">
    <div class="dx-field-label text-uppercase">{{ labelZip }}  <span *ngIf="boolRequired && requiredZip" class="mandatory" title="Required Field"> *</span></div>
    <dx-text-box [(value)]="zip" [inputAttr]="{ 'autocomplete': 'do-not-autofill' }">
      <dx-validator *ngIf="boolRequired && requiredZip">
        <dxi-validation-rule type="required" message="Zip is required"></dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
  </div>

  <div *ngIf="boolZip && countryIso2 === 'US' && allowZip4" class="mb-0 ms-0" [ngClass]="getColClass('zip')">
    <div class="d-flex flex-row w-100 align-items-center gap-2">

      <div class="dx-field w-100 ms-0 mb-0">
        <div class="dx-field-label text-uppercase">{{ labelZip }}  <span *ngIf="boolRequired && requiredZip" class="mandatory" title="Required Field"> *</span></div>
        <dx-text-box [(value)]="zip" [inputAttr]="{ 'autocomplete': 'do-not-autofill' }">
          <dx-validator *ngIf="boolRequired && requiredZip">
            <dxi-validation-rule type="required" message="Zip is required"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>

      <div style="margin-top: 2rem;">-</div>

      <div class="dx-field w-100 ms-0 mb-0">
        <div class="dx-field-label text-uppercase">{{ labelZip4 }}  <span *ngIf="boolRequired && requiredZip4" class="mandatory" title="Required Field"> *</span></div>
        <dx-text-box [(value)]="zip4" [inputAttr]="{ 'autocomplete': 'do-not-autofill' }">
          <dx-validator *ngIf="boolRequired && requiredZip4">
            <dxi-validation-rule type="required" message="Zip is required"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>

    </div>
  </div>    
</div>